import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function TikTokMonoIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon fill="none" viewBox="0 0 24 24" {...props}>
      <Box as="g" clipPath={`url(#tik-tok-mono-a-${id})`}>
        <Box
          as="path"
          fill="#160C1A"
          d="M5.42 0h13.16a5.42 5.42 0 0 1 3.828 1.6A5.47 5.47 0 0 1 24 5.444v13.112a5.47 5.47 0 0 1-1.593 3.844A5.42 5.42 0 0 1 18.58 24H5.42a5.42 5.42 0 0 1-3.827-1.599A5.47 5.47 0 0 1 0 18.557V5.445A5.47 5.47 0 0 1 1.592 1.6 5.42 5.42 0 0 1 5.42 0"
        />
        <Box
          as="path"
          fill="#fff"
          d="M15.234 3.581c.29 2.502 1.678 3.99 4.088 4.144v2.808c-1.398.138-2.623-.323-4.05-1.177v5.241c.013 6.852-7.323 7.38-9.413 3.976-1.392-2.26-.886-7.69 4.145-8.495v2.851c-1.172.196-1.813.557-2.162 1.23-2.15 4.143 5.367 6.61 4.847-.068V3.581z"
        />
      </Box>
      <Box as="defs">
        <clipPath id={`tik-tok-mono-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
